export type MfaGateMode = "ready" | "challenge" | "enroll";

export function selectMfaGateMode(
  currentLevel: string | null,
  nextLevel: string | null,
  verifiedTotpFactors: number,
): MfaGateMode {
  if (currentLevel === "aal2") return "ready";
  if (nextLevel === "aal2" || verifiedTotpFactors > 0) return "challenge";
  return "enroll";
}

export function isValidTotpCode(value: string): boolean {
  return /^\d{6}$/.test(value);
}
